<div class="overall">
    <ng-container *ngIf="data.widget=='inline'; else notInline">
        <!--<div class='flex-sb-fs t-l' *ngIf="!data.skeletonLoading; else skeletonLoadingWidget" style="background: #FFFFFF;
                                                                                                    border: 1px solid #E0E3EB;
                                                                                                    box-sizing: border-box;
                                                                                                    border-radius: 10px;">
            <div class='w-45p'>
                <a (click)="trackOppWidgetEvent('Opportunity widget', 'Album-Banner', fromForGA); goToOppDetailPage($event);" *ngIf="opp.is_background_required; else fullBanner;" routerLink="/{{global.oppDetailPrefix}}/{{opp.oppor_slug}}" class='bannerCont bg-grey block relative' [style.background]="opp.background_color">
                    <img [class.square]="opp.is_banner_square && opp.is_background_required" [class.rectangle]="!opp.is_banner_square && opp.is_background_required" [lazyLoad]="opp.opporimage+'?w=400'" [alt]="opp.opporname">
                </a>
                <ng-template #fullBanner>
                    <a (click)="trackOppWidgetEvent('Opportunity widget', 'Album-Banner', fromForGA); goToOppDetailPage($event);" routerLink="/{{global.oppDetailPrefix}}/{{opp.oppor_slug}}" class='bannerCont bg-grey block relative bgImageFull' [lazyLoad]="opp.opporimage+'?w=400'" defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-opp-image.png">
                    </a>
                </ng-template>
            </div>
            <div class="w-55p p-l-10">
                <h3 class='w-full t-l'><a (click)="trackOppWidgetEvent('Opportunity widget', 'Title', fromForGA); goToOppDetailPage($event);" routerLink="/{{global.oppDetailPrefix}}/{{opp.oppor_slug}}" class="block t-l text-ellipsis">{{opp.opporname}}</a></h3>
                <div *ngIf="opp.is_upcoming_opportunity && !opp.is_upcoming_saved" class='w-full m-t-5 btn btn-default flex-c-c pointer' (click)="trackOppWidgetEvent('Opportunity widget', 'Notify me on launch', fromForGA); saveOpportunity(1, 1);">
                    <i class='fa fa-star-o'></i>
                    <span class='m-l-5'>Notify me on launch</span>
                </div>
                <div *ngIf="opp.is_upcoming_opportunity && opp.is_upcoming_saved" class='w-full m-t-5 btn btn-default blue-i flex-c-c pointer' (click)="trackOppWidgetEvent('Opportunity widget', 'Undo Notify me on launch', fromForGA); saveOpportunity(0, 0);">
                    <i class='fa fa-star'></i>
                    <span class='m-l-5'>Saved</span>
                </div>
                <div *ngIf="!opp.is_upcoming_opportunity" class='m-t-2 text-muted text-xs'>Apply by {{global.formatedDate(opp.last_date_application)}}</div>
                <div *ngIf="!opp.is_upcoming_opportunity" class='m-t-2 text-muted text-xs'>
                    <ng-container *ngIf="global.daysLeft(opp.last_date_application) == 0">
                        <span class='blue'>Last day</span>
                    </ng-container>
                    <ng-container *ngIf="global.daysLeft(opp.last_date_application) == 1">
                        <span class='blue'>1 day to go</span>
                    </ng-container>
                    <ng-container *ngIf="global.daysLeft(opp.last_date_application) > 1">
                        <span class='blue'>{{global.daysLeft(opp.last_date_application)}} days to go</span>
                    </ng-container>
                    <ng-container *ngIf="global.daysLeft(opp.last_date_application) < 0">
                        <span class='text-danger'>Applications closed</span>
                    </ng-container>
                </div>
            </div>
        </div>
        <ng-template #skeletonLoadingWidget>
            <div class="w-full h-70 skeletonLoading">
            </div>
        </ng-template> -->
    </ng-container>

    <ng-template #skeletonLoadingWidget>
        <div class="w-full h-70 skeletonLoading"></div>
    </ng-template>

    <ng-template #notInline>
        <!-- <span class="pro-badge" *ngIf="opp.is_prime>0"><img src="../../../assets/subscription/crown.svg" class="mr-2" width="14px"
            alt="pro">Songdew Pro</span> -->
        <div class='h-full t-l cardborder' *ngIf="!myoppStatus && !data.skeletonLoading; else skeletonLoadingWidget"
            style="margin-right:5px;height:190px;" proBadge [show]="opp.is_prime>0">
            <a (click)="trackOppWidgetEvent('Opportunity widget', 'Click-Detail', fromForGA); goToOppDetailPage($event);"
                routerLink="/{{global.oppDetailPrefix}}/{{opp.oppor_slug}}" class='cardLink'>
                <div style="display:flex" class="cardupper">
                    <div style="flex:30%" class="imgflex">
                        <img class="circleimg" [lazyLoad]="opp.opimage+'?w=500'"
                            defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-opp-image.png">
                    </div>
                    <div style="flex:70%" class="contentflex">
                        <div class='license'>{{global.replace(opp.opportunity_types_choice,'_', ' ')}}</div>
                        <div class="oppname">{{opp.opporname}}</div>
                    </div>
                </div>
            </a>
            <hr class="divhr">
            <div style="display:flex;align-items:center" class="downflex">
                <div class='l-h-1 applybutton'>
                    <a (click)="trackOppWidgetEvent('Opportunity widget', 'Click-Detail', fromForGA); goToOppDetailPage($event);"
                        routerLink="/{{global.oppDetailPrefix}}/{{opp.oppor_slug}}">
                        <ng-container
                            *ngIf="!opp.is_upcoming_opportunity && global.daysLeft(opp.last_date_application) < 0">
                            <span class="closedtag">Closed</span>
                        </ng-container>
                        <ng-container
                            *ngIf="!opp.is_upcoming_opportunity && global.daysLeft(opp.last_date_application) == 0">
                            Last day
                        </ng-container>
                        <ng-container
                            *ngIf="!opp.is_upcoming_opportunity && global.daysLeft(opp.last_date_application) == 1">
                            1 day left
                        </ng-container>
                        <ng-container
                            *ngIf="!opp.is_upcoming_opportunity && global.daysLeft(opp.last_date_application) > 1">
                            {{global.daysLeft(opp.last_date_application)}} days left
                        </ng-container>
                        <ng-container *ngIf="opp.is_upcoming_opportunity">
                            Upcoming
                        </ng-container>
                    </a>
                </div>
                <div class="p-15-10 p-l-5">
                    <div class="flex-sb-c grey text-xs ">
                        <span>
                            <a (click)="trackOppWidgetEvent('Opportunity widget', 'Click-Detail', fromForGA); goToOppDetailPage($event);"
                                routerLink="/{{global.oppDetailPrefix}}/{{opp.oppor_slug}}">
                                <ng-container
                                    *ngIf="!opp.is_upcoming_opportunity && global.daysLeft(opp.last_date_application) >= 0 && !opp.is_applied">
                                    Apply by {{global.formatedDate(opp.last_date_application)}}</ng-container>
                                <ng-container
                                    *ngIf="!opp.is_upcoming_opportunity && global.daysLeft(opp.last_date_application) >= 0 && opp.is_applied">
                                    Applied</ng-container>
                            </a>
                        </span>

                        <a *ngIf="!opp.is_applied && global.daysLeft(opp.last_date_application) >= 0 && !opp.is_saved && !opp.is_upcoming_opportunity"
                            class='save-button pointer t-r  bookmark'
                            (click)="trackOppWidgetEvent('Opportunity widget', 'Bookmark', fromForGA); saveOpportunity(1);">
                        </a>
                        <a *ngIf="!opp.is_applied && global.daysLeft(opp.last_date_application) >= 0 && !opp.is_saved && opp.is_upcoming_opportunity"
                            class='save-button pointer t-r'
                            (click)="trackOppWidgetEvent('Opportunity widget', 'Notify On Launch', fromForGA); saveOpportunity(1);">
                        </a>
                        <a *ngIf="!opp.is_applied && global.daysLeft(opp.last_date_application) >= 0 && opp.is_saved"
                            class='saved-button pointer'
                            (click)="trackOppWidgetEvent('Opportunity widget', 'Bookmark', fromForGA); saveOpportunity(0);">
                        </a>
                        <a *ngIf="!(!opp.is_applied && global.daysLeft(opp.last_date_application) >= 0)"
                            class='saved-button'
                            style="pointer-events: none; visibility: none; opacity: 0;margin-right: 0;">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>


    <ng-container *ngIf="myoppStatus==true">
        <div class='h-full t-l cardborder' *ngIf="!data.skeletonLoading; else skeletonLoadingWidget"
            style="margin-right:5px;height:190px;">

            <div style="display:flex" class="cardupper">
                <div style="flex:30%" class="imgflex">
                    <img class="circleimg" [lazyLoad]="opp.opimage+'?w=500'"
                        defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-opp-image.png">
                </div>
                <div style="flex:70%" class="contentflex">
                    <div class='license d-flex justify-content-between'>
                        <span>opopo{{global.replace(opp.opportunity_types_choice,'_', ' ')}}</span>
                        <span>
                            <a *ngIf="opp.is_saved" class='saved-button pointer'
                                style="padding-left: 20px !important;padding-bottom: 5px;"
                                (click)=" saveOpportunity(0);">
                            </a>
                            <a *ngIf="!opp.is_saved" class='unsave-button pointer'
                                style="padding-left: 20px !important;padding-bottom: 5px;"
                                (click)="saveOpportunity(1);">
                            </a>
                        </span>
                    </div>
                    <div class="oppname">{{opp.opporname}}</div>
                </div>
            </div>

            <hr class="divhr">
            <div style="display:flex;align-items:center" class="downflex">
                <div class='l-h-1 applybutton'>
                    <ng-container
                        *ngIf="!opp.is_upcoming_opportunity && global.daysLeft(opp.last_date_application) < 0">
                        <span class="closedtag">Closed</span>
                    </ng-container>
                    <ng-container
                        *ngIf="!opp.is_upcoming_opportunity && global.daysLeft(opp.last_date_application) == 0">
                        0 day left
                    </ng-container>
                    <ng-container
                        *ngIf="!opp.is_upcoming_opportunity && global.daysLeft(opp.last_date_application) == 1">
                        1 day left
                    </ng-container>
                    <ng-container
                        *ngIf="!opp.is_upcoming_opportunity && global.daysLeft(opp.last_date_application) > 1">
                        {{global.daysLeft(opp.last_date_application)}} days left
                    </ng-container>
                    <ng-container *ngIf="opp.is_upcoming_opportunity">
                        Upcoming
                    </ng-container>
                </div>
                <div class="p-15-10">

                    <span class="d-flex justify-content-end">
                        <ng-container
                            *ngIf="!opp.is_upcoming_opportunity && global.daysLeft(opp.last_date_application) >= 0 && !opp.is_applied">
                            <a class='MyOppbtn' routerLink="/{{global.oppDetailPrefix}}/{{opp.oppor_slug}}"
                                (click)="goToOppDetailPage($event);">Apply Now
                            </a>
                        </ng-container>
                        <!-- <ng-container
                                *ngIf="!opp.is_upcoming_opportunity && global.daysLeft(opp.last_date_application) >= 0 && opp.is_applied">
                                Applied</ng-container> -->

                    </span>

                    <!-- <a *ngIf="!opp.is_applied && global.daysLeft(opp.last_date_application) >= 0 && !opp.is_saved && !opp.is_upcoming_opportunity"
                            class='save-button pointer t-r  bookmark'
                            (click)="trackOppWidgetEvent('Opportunity widget', 'Bookmark', fromForGA); saveOpportunity(1);">
                        </a>
                        <a *ngIf="!opp.is_applied && global.daysLeft(opp.last_date_application) >= 0 && !opp.is_saved && opp.is_upcoming_opportunity"
                            class='save-button pointer t-r'
                            (click)="trackOppWidgetEvent('Opportunity widget', 'Notify On Launch', fromForGA); saveOpportunity(1);">1
                        </a>
                        <a *ngIf="!opp.is_applied && global.daysLeft(opp.last_date_application) >= 0 && opp.is_saved"
                            class='saved-button pointer'
                            (click)="trackOppWidgetEvent('Opportunity widget', 'Bookmark', fromForGA); saveOpportunity(0);">
                        </a>
                        <a *ngIf="!(!opp.is_applied && global.daysLeft(opp.last_date_application) >= 0)"
                            class='saved-button'
                            style="pointer-events: none; visibility: none; opacity: 0;margin-right: 0;">
                        </a> -->

                </div>
            </div>
        </div>
    </ng-container>




</div>